import { render, staticRenderFns } from "./UploadPhotoPage.vue?vue&type=template&id=483c0bd0"
import script from "./UploadPhotoPage.vue?vue&type=script&lang=js"
export * from "./UploadPhotoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports